/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { ExtendedBlob } from 'app/shared/models/extended-blob';

export function downloadFileFromExtendedBlob(extendedBlob: ExtendedBlob): void {
  const objectUrl = window.URL.createObjectURL(extendedBlob.blob);
  const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

  a.href = objectUrl;
  a.download = extendedBlob.metaData;
  document.body.appendChild(a);

  a.click();

  document.body.removeChild(a);
  URL.revokeObjectURL(objectUrl);
}
export function loadUrlToNewTargetViaLinkClick(
  url: string,
  target: string
): void {
  const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

  a.href = url;
  a.target = target;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
